import { useDispatch } from 'app-redux'
import { RootState } from 'common/redux'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import { UUID } from '../../common/types'
import { setReview } from './knowledge-checks-redux'
import KnowledgeCheckReviewGridView from './presentation/knowledge-check-review-grid-view'
import useKnowledgeChecks from './use-knowledge-checks'

const ConfiguredKnowledgeCheckReviewTrainee: FC<{ knowledgeCheckId: UUID }> = ({
	knowledgeCheckId,
}) => {
	const dispatch = useDispatch()
	const roomAddress = useAssertedJoinedRoomAddress()
	const { getReview } = useKnowledgeChecks()
	const training = useSelector((state: RootState) => state.sessionInfo.training)
	const trainerProfile = useSelector(
		(state: RootState) =>
			state.users.all[
				training?.upperEchelon.userId ? training?.upperEchelon.userId : ''
			]
	)
	const review = useSelector((state: RootState) => state.knowledgeChecks.review)

	useEffect(() => {
		if (knowledgeCheckId) {
			getReview(roomAddress, knowledgeCheckId).then(reviewData =>
				dispatch(setReview(reviewData))
			)
		}
	}, [getReview, roomAddress, knowledgeCheckId, dispatch])

	return review ? (
		<KnowledgeCheckReviewGridView
			title={training?.subject}
			userProfile={trainerProfile}
			review={review}
		/>
	) : null
}

export default ConfiguredKnowledgeCheckReviewTrainee
